import Badges from "./Badges";
import PlotSettings from "./PlotSettings";

import "./PlotHeader.css";

import { yAxisOptionsValueToLabel } from "../js/constants";

const PlotHeader = ({
  isLoading,
  hasPlotData,
  alertsPlotYAxisVar,
  setAlertsPlotYAxisVar,
  jamsOrIrregularitiesPlotYAxisVar,
  setJamsOrIrregularitiesPlotYAxisVar,
  recordsCount,
  eventsCount,
  congestionRate,
  hasFetchFailed,
  loadingTime,
  isAlertSelected,
  isRoadSegmentSelected,
}) => {
  const plotYAxisVarOptions = {
    alerts: [
      {
        value: "reliability",
        label: yAxisOptionsValueToLabel.reliability,
      },
      {
        value: "n_thumbs_up",
        label: yAxisOptionsValueToLabel.n_thumbs_up,
      },
    ],
    jamsOrIrregularities: [
      {
        value: "congestion_coefficient",
        label: yAxisOptionsValueToLabel.congestion_coefficient,
      },
      {
        value: "delay_minutes",
        label: yAxisOptionsValueToLabel.delay_minutes,
      },
      {
        value: "travel_time_minutes",
        label: yAxisOptionsValueToLabel.travel_time_minutes,
      },
    ],
  };

  return (
    <div className="plot-header">
      {!isLoading && hasPlotData && (
        <>
          {isAlertSelected && (
            <PlotSettings
              options={plotYAxisVarOptions.alerts}
              yAxisVar={alertsPlotYAxisVar}
              setYAxisVar={setAlertsPlotYAxisVar}
            />
          )}
          {isRoadSegmentSelected && (
            <PlotSettings
              options={plotYAxisVarOptions.jamsOrIrregularities}
              yAxisVar={jamsOrIrregularitiesPlotYAxisVar}
              setYAxisVar={setJamsOrIrregularitiesPlotYAxisVar}
            />
          )}
          <Badges
            recordsCount={recordsCount}
            eventsCount={eventsCount}
            congestionRate={congestionRate}
            loadingTime={loadingTime}
            displayLoadingTime={
              !isLoading &&
              !hasFetchFailed &&
              (isAlertSelected || isRoadSegmentSelected)
            }
          />
        </>
      )}
    </div>
  );
};

export default PlotHeader;
